export default __webpack_public_path__ + "static/media/FullPhone.189f5eab.png";